import { Button } from '@/components/ui/button';
import { Pencil, Save, X, Loader2 } from 'lucide-react';

interface EditableCardActionsProps {
  isEditing: boolean;
  isSaving: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

export function EditableCardActions({
  isEditing,
  isSaving,
  onEdit,
  onSave,
  onCancel,
}: EditableCardActionsProps) {
  if (!isEditing) {
    return (
      <Button variant="ghost" size="icon-sm" onClick={onEdit}>
        <Pencil className="h-4 w-4" />
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="icon-sm"
        onClick={onCancel}
        disabled={isSaving}
      >
        <X className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon-sm"
        onClick={onSave}
        disabled={isSaving}
        className="text-green-600 hover:text-green-700 hover:bg-green-50"
      >
        {isSaving ? (
          <Loader2 className="h-4 w-4 animate-spin" />
        ) : (
          <Save className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
}
